/**
 * 文件说明: 消息详情
 * ----------------------------------------
 * 创建用户: 1625
 * 创建日期 2021/02/04
 */

import {createProjectModel} from 'crm/utils/project-model'
import {getOverview, getDetail} from './service'

const initState = {
    overview: {}, //  客户列表
    showType: 'employee', // employee | customer
}
const model = createProjectModel({
    projectNamespace: 'messagesDetail',
    state: {
        ...initState,
    },

    effects: {
        *overview({payload}, {put, call}) {
            const res = yield call(getOverview, {
                id: payload.id,
            })
            yield put({
                type: 'immerCb',
                payload: (draft) => {
                    draft.overview = {
                        confirmed_count: res.data.confirmed_count,
                        unconfirmed_count: res.data.unconfirmed_count,
                        confirmed_count_rate:
                            (res.data.confirmed_count /
                                (res.data.confirmed_count + res.data.unconfirmed_count)) *
                            100,
                        unconfirmed_count_rate:
                            (res.data.unconfirmed_count /
                                (res.data.confirmed_count + res.data.unconfirmed_count)) *
                            100,
                    }
                },
            })
        },
        *detail({payload}, {put, call}) {
            const res = yield call(getDetail, {
                id: payload.id,
            })
            yield put({
                type: 'immerCb',
                payload: (draft) => {
                    draft.detail = res.data
                },
            })
        },
        *reset(__, {put}) {
            yield put({
                type: 'immerCb',
                payload: (draft) => {
                    draft.showType = initState.showType
                    draft.overview = {}
                },
            })
        },
    },
})
export default model
